// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card__SH0et"};